import React from 'react';
import theme from 'theme';

/**
 * Speak icon
 *
 * @param {string} width
 * @param {string} color
 */
export const SpeakIcon = ({width, color}) => {
    const DEFAULT_WIDTH = '25';
    const DEFAULT_COLOR = theme.colors.text.secondary;

    return (
        <svg
            // enable-background="new 0 0 24 24"
            // height="30"
            viewBox="0 0 24 24"
            width={width || DEFAULT_WIDTH}
            xmlns="http://www.w3.org/2000/svg"
            fill={theme.colors[color] || DEFAULT_COLOR}
        >
            <g>
                <g>
                    <g>
                        <path
                            d="m5 18c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3zm0-5c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2z"/>
                    </g>
                </g>
                <g>
                    <g>
                        <path
                            d="m9.5 24c-.276 0-.5-.224-.5-.5v-1.777c0-.951-.716-1.723-1.596-1.723h-4.808c-.88 0-1.596.772-1.596 1.723v1.777c0 .276-.224.5-.5.5s-.5-.224-.5-.5v-1.777c0-1.501 1.164-2.723 2.596-2.723h4.809c1.431 0 2.595 1.222 2.595 2.723v1.777c0 .276-.224.5-.5.5z"/>
                    </g>
                </g>
            </g>
            <g>
                <g>
                    <path
                        d="m10.5 16c-.112 0-.225-.038-.315-.112-.153-.125-.219-.329-.167-.52l.827-3.021c-1.813-1.331-2.845-3.262-2.845-5.347 0-3.859 3.589-7 8-7s8 3.141 8 7c0 4.229-4.365 7.601-9.286 6.908l-3.986 2.037c-.073.037-.15.055-.228.055zm5.5-15c-3.859 0-7 2.691-7 6 0 1.856.983 3.578 2.697 4.724.18.12.262.341.205.548l-.621 2.268 3.121-1.595c.094-.049.201-.065.307-.049 4.371.703 8.291-2.224 8.291-5.896 0-3.309-3.141-6-7-6z"/>
                </g>
            </g>
            <g>
                <g>
                    <path
                        d="m14.5 9.5c-.128 0-.256-.049-.354-.146l-2-2c-.195-.195-.195-.512 0-.707s.512-.195.707 0l1.647 1.646 3.646-3.646c.195-.195.512-.195.707 0s.195.512 0 .707l-4 4c-.097.097-.225.146-.353.146z"/>
                </g>
            </g>
        </svg>
    );
};
